import { ReactElement } from "react";
import { useFetch } from "../../../system/useFetch";
import {  INotificationSubscription, INotificationTopic } from "../../../types";
import TableContainer from "../../tableContainer";
import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import StyledTableRow from "../../styledTableRow";


interface IProps {
  subscriptions: INotificationSubscription[];
  updateSubscriptions: (item: INotificationSubscription) => void;
}

const NotificationPanel = ({ updateSubscriptions, subscriptions }: IProps): ReactElement => {
  const { data: topics } = useFetch<INotificationTopic[]>(
    {
      module: "notification",
      query: "getTopics",
      payload: {}
    });

  const onChecked = (item: INotificationSubscription, prop: keyof INotificationSubscription, value: boolean) => {
    (item as any)[prop] = value;
    updateSubscriptions(item);
  };

  return (
    <TableContainer sx={{ maxHeight: 582 }}>
      <Table stickyHeader={true} size={"small"}>
        <TableHead >
          <TableRow >
            <TableCell sx={{ backgroundColor: "#b0bec5" }} style={{ minWidth: 100 }}>
              Area
            </TableCell>
            <TableCell sx={{ backgroundColor: "#b0bec5" }} style={{ minWidth: 100 }}>
              Topic
            </TableCell>
            <TableCell sx={{ backgroundColor: "#b0bec5" }} style={{ minWidth: 50 }}>
              App
            </TableCell>
            <TableCell sx={{ backgroundColor: "#b0bec5" }} style={{ minWidth: 50 }}>
              Bot
            </TableCell>
            <TableCell sx={{ backgroundColor: "#b0bec5" }} />
          </TableRow>
        </TableHead>
        <TableBody>
          { topics && topics.map(topic => {
            const subscription = subscriptions.find(s => s.topicID === topic.topicID) ?? {
              topicID: topic.topicID,
              app: false,
              bot: false,
              email: false
            };

            return (
              <StyledTableRow hover={true} role="checkbox" tabIndex={-1} key={`topic-row-${topic.code}`}>
                <TableCell>
                  {topic.areaName}
                </TableCell>
                <TableCell>
                  {topic.name}
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={subscription.app}
                    tabIndex={-1}
                    disableRipple={true}
                    onChange={() => onChecked(subscription, "app", !subscription.app)}/>
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={subscription.bot}
                    tabIndex={-1}
                    disableRipple={true}
                    onChange={() => onChecked(subscription, "bot", !subscription.bot)}/>
                </TableCell>
                <TableCell/>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};


export default NotificationPanel;